import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  discountCode: null,
  discountedPrice: null,
  validDiscountCode: null,
  invalidDiscountCodeMessage: null,
  discountCodeMinOrderAmountMet: null,
  enteredDiscountCode: null,
  appliedInCart: false,
};

export const cartDiscountSlice = createSlice({
  name: "cartDiscount",
  initialState,
  reducers: {
    setCartDiscountCode: (state, action) => {
      state.discountCode = action.payload;
    },
    setCartDiscountedPrice: (state, action) => {
      state.discountedPrice = action.payload;
    },
    setCartValidDiscountCode: (state, action) => {
      state.validDiscountCode = action.payload;
    },
    setCartInvalidDiscountCodeMessage: (state, action) => {
      state.invalidDiscountCodeMessage = action.payload;
    },
    setCartDiscountCodeMinOrderAmountMet: (state, action) => {
      state.discountCodeMinOrderAmountMet = action.payload;
    },
    setCartEnteredDiscountCode: (state, action) => {
      state.enteredDiscountCode = action.payload;
    },
    setCartDiscountApplied: (state, action) => {
      state.appliedInCart = action.payload;
    },
    clearCartDiscount: (state) => {
      state.discountCode = null;
      state.discountedPrice = null;
      state.validDiscountCode = null;
      state.invalidDiscountCodeMessage = null;
      state.discountCodeMinOrderAmountMet = null;
      state.enteredDiscountCode = null;
      state.appliedInCart = false;
    },
    setCartDiscountState: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const {
  setCartDiscountCode,
  setCartDiscountedPrice,
  setCartValidDiscountCode,
  setCartInvalidDiscountCodeMessage,
  setCartDiscountCodeMinOrderAmountMet,
  setCartEnteredDiscountCode,
  setCartDiscountApplied,
  clearCartDiscount,
  setCartDiscountState,
} = cartDiscountSlice.actions;

// Thunks for complex operations
export const applyCartDiscountCode =
  (discountData) => (dispatch) => {
    dispatch(setCartDiscountCode(discountData.code));
    dispatch(setCartDiscountedPrice(discountData.discountedPrice));
    dispatch(setCartValidDiscountCode(discountData.valid));
    dispatch(setCartEnteredDiscountCode(discountData.enteredCode));
    dispatch(setCartDiscountApplied(true));
    if (discountData.minOrderAmountMet !== undefined) {
      dispatch(setCartDiscountCodeMinOrderAmountMet(discountData.minOrderAmountMet));
    }
  };

export const removeCartDiscountCode = () => (dispatch) => {
  dispatch(clearCartDiscount());
};

export default cartDiscountSlice.reducer;
